import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

export default function Header({ onShare }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  return (
    <>
      <header className={`header${scrolled ? ' header--scrolled' : ''}`}>
        <div className="header__inner">
          <a href="https://salarycalculatorapp.com/" className="header__logo" aria-label="SalaryLens Home">
            <span className="header__logo-icon">◈</span>
            <span className="header__logo-text">SalaryLens</span>
          </a>

          <nav className="header__nav" aria-label="Main navigation">
            <a href="https://salarycalculatorapp.com/" className="header__nav-link">Calculator</a>
            <a href="https://salarycalculatorapp.com/#compare" className="header__nav-link">Compare</a>
            <a href="https://salarycalculatorapp.com/#faq" className="header__nav-link">FAQ</a>
            <a href="https://salarycalculatorapp.com/about" className="header__nav-link">About</a>
          </nav>

          <div className="header__actions">
            <button className="header__share-btn" onClick={onShare} aria-label="Share calculator">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>
                <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
              </svg>
              <span>Share</span>
            </button>
            <button className="header__menu-btn" onClick={() => setMenuOpen(true)} aria-label="Open menu" aria-expanded={menuOpen}>
              <span /><span /><span />
            </button>
          </div>
        </div>
      </header>

      {menuOpen && (
        <div className="mobile-nav" role="dialog" aria-modal="true" aria-label="Mobile navigation">
          <div className="mobile-nav__overlay" onClick={() => setMenuOpen(false)} />
          <div className="mobile-nav__drawer">
            <div className="mobile-nav__header">
              <span className="header__logo-text">SalaryLens</span>
              <button className="mobile-nav__close" onClick={() => setMenuOpen(false)} aria-label="Close menu">✕</button>
            </div>
            <nav className="mobile-nav__links">
              {[
                { href: 'https://salarycalculatorapp.com/', label: 'Calculator', icon: '◈' },
                { href: 'https://salarycalculatorapp.com/#compare', label: 'Compare Countries', icon: '⊞' },
                { href: 'https://salarycalculatorapp.com/#faq', label: 'FAQ', icon: '?' },
                { href: 'https://salarycalculatorapp.com/about', label: 'About', icon: 'ℹ' },
              ].map(({ href, label, icon }) => (
                <a key={label} href={href} className="mobile-nav__link" onClick={() => setMenuOpen(false)}>
                  <span className="mobile-nav__link-icon">{icon}</span>
                  {label}
                </a>
              ))}
            </nav>
            <button className="mobile-nav__share" onClick={() => { onShare(); setMenuOpen(false); }}>
              Share Results
            </button>
          </div>
        </div>
      )}
    </>
  );
}

Header.propTypes = {
  onShare: PropTypes.func.isRequired,
}